import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import {MatButtonModule } from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-buttons',
  imports: [MatButtonModule, MatDividerModule, MatIconModule,MatCheckboxModule],
  templateUrl: './visualing-theme.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./visualing-theme.component.scss', '../styles_color_theme.scss'],
})
export class VisualingTheme implements OnInit  {
  // public red : string ='red';
  private _snackBar = inject(MatSnackBar);
  selectedColorTheme: string ='';
  selectedColorMaterial: string ='';
	public colors_angular: Array<string> = [
    '$red-palette' ,
    '$green-palette' ,
    '$blue-palette' ,
    '$yellow-palette' ,
    '$cyan-palette' ,
    '$magenta-palette' ,
    '$orange-palette' ,
    '$chartreuse-palette' ,
    '$spring-green-palette' ,
    '$azure-palette' ,
    '$violet-palette' ,
    '$rose-palette' 
  ];

  public colors_theme: Array<string> = [
    'primary',
    'info',
    'secondary',
    'tertiary',
    'success',
    'neutral',
    'neutral-variant',
    'warning',
    'error',
  ];

  ngOnInit(): void {
    // this.savePrimaryAndAccentColor();
    // this.show(message, { panelClass: ['snackbar-container', 'error'] });
    // this._snackBar.open('message', 'action',{ panelClass: [ 'success'] });
    // this._snackBar.open('messageqsdf', 'actionqsdf',{ panelClass: [ 'error'] });
  }


changeColor (color : string, theme:string) {
  console.log(' salut from changeColor ', color);
  if (theme ==='theme') {  
    this.selectedColorTheme = color;
    this._snackBar.open('message', 'action',{ panelClass: [ color] });
  }
  if (theme ==='material') {  this.selectedColorMaterial = color;}
  
  // this.primaryColor = getComputedStyle(this.primaryElement.nativeElement).color;
}

openSnackBar(color:string){
  console.log('color',color);
  this._snackBar.open('message', 'action',{ panelClass: [ color] });
}

// onKeydown(event: any) {
//   if (event.key === "Enter") {
//     // console.log(event);
//     this.onSearch();
//   }
// }

}
